var map = {
	"./de/countries.json": 54580,
	"./de/email.json": 37400,
	"./de/shopify.json": 72046,
	"./de/translation.json": 33627,
	"./en-GB/countries.json": 59815,
	"./en-GB/translation.json": 53384,
	"./en/countries.json": 95194,
	"./en/email.json": 87940,
	"./en/shopify.json": 34343,
	"./en/translation.json": 47380,
	"./es-MX/countries.json": 34546,
	"./es-MX/email.json": 32869,
	"./es-MX/shopify.json": 40107,
	"./es-MX/translation.json": 13733,
	"./es/countries.json": 35811,
	"./es/shopify.json": 61162,
	"./fr/countries.json": 98883,
	"./fr/email.json": 58336,
	"./fr/shopify.json": 77497,
	"./fr/translation.json": 28467,
	"./it/countries.json": 35426,
	"./it/email.json": 99668,
	"./it/shopify.json": 97894,
	"./it/translation.json": 75669,
	"./nl/countries.json": 81324,
	"./nl/shopify.json": 58043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59382;